export const findAllowedAction = (allowedActions, reviewType) =>
  allowedActions?.find((action) => action.reviewType === reviewType) ?? null;

export const getAllowedActionsByGroup = (allowedActions) => ({
  OCF: allowedActions?.filter((action) => action.programme === "OCF") ?? [],
  PP: allowedActions?.filter((action) => action.programme === "PP") ?? [],
  CDM: allowedActions?.filter((action) => action.programme === "CDM") ?? [],
});

export const getDeniedActionsByGroup = (deniedActions) => ({
  OCF: deniedActions?.filter((action) => action.programme === "OCF") ?? [],
  PP: deniedActions?.filter((action) => action.programme === "PP") ?? [],
  CDM: deniedActions?.filter((action) => action.programme === "CDM") ?? [],
});

// First human-readable reason a programme is denied (or null). BE scopes each
// denial to its own programme, so an OCF age-denial never affects CDM/PP.
export const getProgrammeDenialReason = (deniedActions, programme) =>
  deniedActions?.find((action) => action.programme === programme)?.reason ??
  null;
